import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import TimeAvailability from '../../components/core/TimesButton/TimeAvailability';
import { AVAILABLE_TIMES_ALT_TEXT } from '../../assets/copy';
import PlaceholderLoader from '../loading/PlaceholderLoader';
import { TIME_AVAILABILITY_TYPES } from '../../pages/venueAvailability/timeAvailabilityTypes';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    overflowX: 'scroll',
    overflowY: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  fadeIn: {
    transition: 'opacity 1s ease',
  },
  fadeOut: {
    opacity: 0,
    transition: 'opacity 1s ease',
  },
  noAvail: {
    margin: `0 ${theme.spacing(1)}`,
  },
  placeholderContainer: {
    width: '100%',
    display: 'flex',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

const VenueResultAvailability = ({ availability, className, type, placeholderLength = 7, ...props }) => {
  const classes = useStyles();
  const [showLoader, setShowLoader] = useState(true);
  const venueResultAvailabilityRef = useRef(null);
  const [venueResultAvailabilityWidth, setVenueResultAvailabilityWidth] = useState(0);
  const onMount = () => {
    setShowLoader(false);
  };

  useEffect(() => {
    if(type === TIME_AVAILABILITY_TYPES.HORIZONTAL_SEARCH_REFRESH && venueResultAvailabilityRef.current) {
      setVenueResultAvailabilityWidth(venueResultAvailabilityRef.current.clientWidth);
    }
  }, [type, venueResultAvailabilityRef]);

  function getPlaceholderLoader() {
    return (
      <Box className={classes.placeholderContainer}>
        <PlaceholderLoader length={placeholderLength} />
      </Box>
    );
  }

  return (
    <Box
      ref={venueResultAvailabilityRef}
      aria-label={AVAILABLE_TIMES_ALT_TEXT}
      className={clsx(classes.root, className)}>
      {!availability ? (
        getPlaceholderLoader()
      ) : (
        <>
          {showLoader && getPlaceholderLoader()}
          <TimeAvailability
            type={type ?? TIME_AVAILABILITY_TYPES.HORIZONTAL_SEARCH}
            item={availability[0] || availability}
            onMount={onMount}
            parentWidth={venueResultAvailabilityWidth}
            {...props}
          />
        </>
      )}
    </Box>
  );
};

export default VenueResultAvailability;
